import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useCancelSubscription = () => {
  const { mutate: cancelSubscription, isPending } = useAppMutation([QueryKey.CANCEL_SUBSCRIPTION], {
    mutationFn: ({ companyId }: { companyId: string }) =>
      ApiService.post({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'cancel-subscription'],
      }),
  });
  return { cancelSubscription, isPending };
};
